import React from 'react';
import PropTypes from 'prop-types';

import termOptions from 'constants/termOptions';

import './style.scss';

const TopOptions = ({ modelName, left, right }) => {
  const termOption = termOptions[modelName];

  return (
    <div styleName="top">
      {modelName ? (
        <div styleName="left">
          <div data-test="pane-title" styleName="title">
            <span className={`icon icon-${termOption.iconClassName}`} />
            {termOption.title}
          </div>
        </div>
      ) : (
        <div styleName="left">{left}</div>
      )}
      <div styleName="right">{right}</div>
    </div>
  );
};

TopOptions.propTypes = {
  left: PropTypes.node,
  modelName: PropTypes.oneOf(Object.keys(termOptions)),
  right: PropTypes.node,
};

TopOptions.defaultProps = {
  modelName: '',
  left: null,
  right: null,
};

export default TopOptions;
